import { FormHelperText } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const VrsCallCommentsHelperText: FC<PropsWithChildren> = ({
  children,
}) => {
  return <StyledFormHelperText>{children}</StyledFormHelperText>;
};

const StyledFormHelperText = styled(FormHelperText)`
  color: ${theme.palette.error.contrastText};
`;
